angular
  .module("AccountingBoxApp")
  .controller("JournalEntriesEditCtrl", function(
    $scope,
    $rootScope,
    $state,
    $filter,
    JournalEntry,
    $stateParams,
    Contact,
    Attachment,
    Account,
    VatCode,
    Purchase,
    Sale,
    SubAccount,
  ) {
    var vm = this;
    var journalEntry;
    var customers;
    var subAccounts;
    var attachment;
    var paymentInvoices = [];

    $scope.options = {
      language: "nl",
      todayHighlight: true,
      format: "dd-mm-yyyy",
      autoclose: true,
      orientation: 'bottom'
    };

    $scope.order = {
      by: ["checked", "dueDate"],
      reverse: true,
      filter: ""
    };

    $scope.optionsAccounts = {
      minLength: 2
    };

    vm.extractedWords = [];
    vm.extractedNumbers = [];

    vm.loadInvoices = function() {
      var sales = Sale.find({
        filter: {
          where: { status: { neq: "paid" } },
          include: "customer"
        }
      });
      vm.sales = sales;
      var purchases = Purchase.find({
        filter: {
          where: { status: { neq: "paid" } },
          include: "vendor"
        }
      });
      vm.purchases = purchases;
    };
    vm.loadInvoices();

    vm.transactions = [];
    setTimeout(function() {
      vm.accounts = Account.findApplicable();
      vm.vatCodes = VatCode.find({
        filter: {
          where: {
            or: [{ sale: true }, { purchase: true }]
          }
        }
      });
      vm.refreshSubAccounts();
    }, 1000);

    Account.systemAccounts(function(result) {
      vm.systemAccounts = result.systemAccounts;
    });

    vm.refreshSubAccounts = function() {
      SubAccount.find(function(subA) {
        // vm.subAccounts=subA;
        subAccounts = subA;
      });
    };
    vm.subAccountsFiltered = function(item) {
      // if (item && item.account) {
      //   var aN = item.account.accountNumber;
      //   var subAccountType = vm.subAccountType(item);
      //   return _.filter(vm.subAccounts, function(a) {
      //     return a.type === subAccountType;
      //   });
      // } else {
      return vm.subAccounts;
      // }
    };

    vm.subAccountType = function(item) {
      var aN = 0;
      if (item && item.account) {
        aN = item.account.accountNumber;
      }
      if (
        (aN >= 213000 && aN <= 213030) ||
        aN == 4102070 ||
        aN == 4106070 ||
        (aN >= 4205000 && aN <= 4205990)
      ) {
        return "VEHICLE";
      } else if (
        (aN >= 509000 && aN <= 509080) ||
        aN == 1103140 ||
        aN == 1103120 ||
        aN == 1209010 ||
        aN == 1209020 ||
        aN == 9005010 ||
        aN == 306010 ||
        aN == 806030 ||
        aN == 8401060 ||
        aN == 8401070 ||
        aN == 8404130 ||
        aN == 8404140 ||
        aN == 4203110
      ) {
        return "PARTNER";
      } else if (
        aN == 301010 ||
        aN == 305010 ||
        aN == 504070 ||
        aN == 8401010 ||
        aN == 8404080 ||
        aN == 8410010
      ) {
        return "PARTICIPATION";
      } else if (
        (aN >= 100000 && aN <= 218030) ||
        (aN >= 4100000 && aN <= 4199030)
      ) {
        return "INVESTMENT";
      } else {
        return "MISCELLANEOUS";
      }
    };

    vm.subAccountSelect = function(subAccount, item) {
      if (subAccount && subAccount.new) {
        SubAccount.create(subAccount, function(subAccount) {
          item.subAccount = subAccount;
          item.subAccountId = subAccount.id;
          SubAccount.find(function(subA) {
            subAccounts = subA;
          });
        });
      }else {
        item.subAccount = subAccount;
        item.subAccountId = (subAccount && subAccount.id) || null;
      }
    };

    vm.refreshSubAccount = function(query, item) {
      vm.subAccounts = $filter("propsFilter")(subAccounts, {
        description: query
      });
      if (vm.subAccounts && query.length > 0) {
        vm.subAccounts.push({
          description: query,
          new: true,
          type: vm.subAccountType(item)
        });
      }
    };

    vm.accountChanged = function(item) {
      vm.updateDestinationNumberOfMonths(item);
      var type = vm.subAccountType(item);
      if (type === "INVESTMENT") {
        if (!vm.showExtra(item)) {
          vm.checkExtra(item);

          // if((item.account.accountNumber>=100000&&item.account.accountNumber<=218030)){
          if (!item.destination) {
            item.destination = {};
          }
          item.destination.residualValue = 0;
          // }else{
          //     if (!item.subAccount) {
          //         item.subAccount = vm.subAccounts(item)[0];
          //     }
          // }
        }
      }
    };

    vm.updateDestinationNumberOfMonths = function(item) {
      if (item.destination && item.destination.bookingValue && item.amount) {
        if (
          item.account?.accountNumber >= 100000 &&
          item.account?.accountNumber <= 218030
        ) {
          var dnm = 60;
          if (item.account?.accountNumber === 107010) {
            dnm = 120;
          }

          var monthlyDepreciation =
            (item.amount - item.destination.residualValue) / dnm;
          item.destination.numberOfMonths = Math.round(
            (item.destination.bookingValue - item.destination.residualValue) /
              monthlyDepreciation
          );
        }
      }
    };

    vm.showBookingValue = function(item) {
      //   console.log('item is:',item);
      if (
        vm.journalEntry.isOpeningBalance &&
        item.account &&
        item.account?.accountNumber >= 100000 &&
        item.account?.accountNumber <= 218030
      ) {
        return true;
      } else {
        return false;
      }
    };

    $scope.$watch("jee.journalEntry.description", function(newValue, oldValue) {
      if (oldValue === undefined) oldValue = "";
      angular.forEach(journalEntry.Lines, function(line, key) {
        //      console.log('line description:', line.description);

        if (line.description === oldValue || line.description === "") {
          journalEntry.Lines[key].description = newValue;
        }
      });
    });

    vm.toggleInvoice = function(line, transaction) {
      if (line.invoices === undefined) line.invoices = [];
      var index = vm.index(line, transaction);
      if (line.invoices[index]) {
        line.invoices.splice(index, 1);
      } else {
        //  console.log(line, transaction);
        // line.invoices[transaction.id]=transaction.totalAmount;
        //line.invoices[transaction.id] = transaction.totalAmount;
        var invoiceType = "";
        if (line.account?.accountNumber === vm.systemAccounts.DEBTORS) {
          invoiceType = "Sale";
        }
        if (line.account?.accountNumber === vm.systemAccounts.CREDITORS) {
          invoiceType = "Purchase";
        }
        line.invoices.push({
          invoiceId: transaction.id,
          invoiceType: invoiceType,
          paymentAmount: transaction.amountDue
        });
      }
      transaction.checked = vm.checked(line, transaction);
    };

    vm.index = function(line, transaction) {
      return _.findIndex(line.invoices, function(invoice, index) {
        if (invoice.invoiceId == transaction.id) {
          return true;
        }
      });
    };
    vm.checked = function(line, transaction) {
      var index = vm.index(line, transaction);
      if (index > -1) {
        return true;
      } else {
        return false;
      }
    };
    vm.name = function(transaction) {
      if (transaction.customer) return transaction.customer.name;
      else return transaction.vendor.name;
    };

    vm.account = function(item) {
      return _.find(vm.accounts, function(account) {
        return account.accountNumber === item.vatCode.account;
      });
    };

    vm.showExtra = function(item) {
      if (
        item.subAccount ||
        (item.destination && item.destination.account) ||
        (item.destination && item.destination.numberOfMonths) ||
        (item.destination && item.destination.residualValue) ||
        item.showExtra
      ) {
        return true;
      } else {
        return false;
      }
    };

    vm.checkExtra = function(item) {
      if (item.showExtra) {
        item.showExtra = false;
      } else if (!item.showExtra) {
        item.showExtra = true;
      }
    };

    //auto due date

    vm.close = function(saved) {
      if ($state.current.name === "app.company.new.journalEntries") {
        if (saved) {
          $scope.openNextUpload()
        } else {
          $state.go("app.company.inbox");
        }
        // } else if($rootScope.previousState){
        //     $state.go($rootScope.previousState,$rootScope.previousStateParams);
        // }else
        // {
        //     $state.go('app.company.journalEntries.list', {
        //         id: journalEntry.id
        //     });
        // }
      } else {
        window.history.back();
      }
    };
    $scope.$on("close", function() {
      vm.close();
    });

    vm.focus = function(index) {
      if (journalEntry.Lines.length - 1 === index) {
        vm.addItem();
      }
    };
    vm.addItem = function() {
      if (!journalEntry.Lines) {
        journalEntry.Lines = [];
      }
      journalEntry.Lines.push({
        description: journalEntry.description || "",
        amount: null, //,
        invoice: []
        // vatCode: saleVATHigh
      });
    };

    vm.removeItem = function(item) {
      journalEntry.Lines.splice(journalEntry.Lines.indexOf(item), 1);
      if (journalEntry.Lines.length === 0) {
        vm.addItem();
      }
    };

    function roundTwoDecimals(number) {
      return Math.round(number * 100) / 100;
    }

    $scope.$watch("jee.journalEntry.Lines[0].amount", function(
      newValue,
      oldValue
    ) {
      if (newValue && oldValue) {
        vm.totalChanged();
      }
    });

    $scope.$watch("jee.journalDate", function(newValue, oldValue) {
      if (oldValue && newValue) {
        vm.totalChanged();
      }
    });

    $scope.$watch(
      "jee.journalEntry.Lines",
      function(newValue, oldValue) {
        if (
          oldValue &&
          newValue &&
          oldValue[0] &&
          newValue[0] &&
          oldValue[0].vatCode &&
          newValue[0].vatCode
        ) {
          if (newValue[0].vatCode.vatCode !== oldValue[0].vatCode.vatCode) {
            // if(oldValue===undefined){ //Only change first time
            vm.totalChanged(newValue[0]);
          }
        }

        //  console.log('newvalue line changed: ', newValue);
        // if(oldValue===undefined){ //Only change first time
        _.each(newValue, function(line, index) {
          if (
            line.account !==
            undefined /*&& newValue[0].account.accountNumber !== oldValue[0].account.accountNumber*/
          ) {
            var accountNumber = line.account?.accountNumber;
            if (
              accountNumber === vm.systemAccounts.DEBTORS ||
              accountNumber === vm.systemAccounts.CREDITORS
            ) {
              // console.log('invoice screeeeeeeeeeeeeen!');
              //    if(newValue!== undefined ){
              newValue[index].showInvoice = true;

              if (
                oldValue !== undefined &&
                oldValue[index].account &&
                line.account?.accountNumber !==
                  oldValue[index].account?.accountNumber
              ) {
                newValue[index].invoicedClosed = true;
              }
              var debtors = false;
              if (line.account?.accountNumber === vm.systemAccounts.DEBTORS) {
                vm.transactions[index] = paymentInvoices.concat(vm.sales);
                debtors = true;
              }
              if (line.account?.accountNumber === vm.systemAccounts.CREDITORS) {
                vm.transactions[index] = paymentInvoices.concat(vm.purchases);
              }

              var amount = 0;
              _.each(line.invoices, function(invoice, index) {
                amount += invoice.paymentAmount;
              });
              amount = roundTwoDecimals(amount);
              if (debtors) {
                amount = amount * -1;
              }
              if (amount !== 0) {
                newValue[index].amount = amount;
              }
              //  }
            } else {
              newValue[index].showInvoice = false;
            }
          }
        });
      },
      true
    );

    vm.totalChanged = function(l) {
      var numOfFiledLines = 0;
      angular.forEach(journalEntry.Lines, function(line, key) {
        if (Math.abs(line.amount) > 0) {
          numOfFiledLines += 1;
        }
      });
      // if (numOfFiledLines < 3) {
      //   var line = l || journalEntry.Lines[0];
      //   var journalDate = moment(vm.journalDate, "DD-MM-YYYY");
      //   // var percentage = $rootScope.getVatCodePercentage(
      //   //   line.vatCode,
      //   //   journalDate
      //   // );
      //   journalEntry.Lines[1].amount = 0;
      //   var difference = roundTwoDecimals(vm.calculateBookingDifference());
      //   journalEntry.Lines[1].amount = difference;
      // }
    };

    vm.purchaseGrandTotal = function() {
      var total = 0;
      angular.forEach(journalEntry.Lines, function(line, key) {
        if (line.destination && line.destination.bookingValue) {
          total += line.destination.bookingValue; // + vm.calculateTax(line);
        } else {
          total += line.amount + vm.calculateTax(line);
        }
        if (line.vatCode && line.vatCode.secondAccount)
          total -= vm.calculateTax(line);
      });
      return -total;
    };

    vm.calculateTax = function(line) {
      if (line.vatCode && line.vatCode.rates) {
        var journalDate = moment(vm.journalDate, "DD-MM-YYYY");
        return roundTwoDecimals(
          ($rootScope.getVatCodePercentage(line.vatCode, journalDate) *
            line.amount) /
            100
        );
      } else {
        return 0;
      }
    };

    vm.saveDisabled = function() {
      //  console.log(vm.calculateBookingDifference());
      var diff = roundTwoDecimals(Math.abs(vm.calculateBookingDifference()));

      if (
        (journalEntry.roundingDifference &&
          vm.showRoundingDifferenceCheckbox()) ||
        diff === 0
      ) {
        return false;
      }
      return true;
    };
    vm.showRoundingDifferenceCheckbox = function() {
      var diff = roundTwoDecimals(Math.abs(vm.calculateBookingDifference()));
      if (diff < 0.05 && diff !== 0.0) {
        return true;
      }
      return false;
    };

    vm.calculateBookingDifference = function() {
      //   console.log(purchase.totalAmount);
      return vm.purchaseGrandTotal(); /// + vm.invoiceSubTotal();
    };

    function dateformatting() {
      $("#invoiceDatePicker").datepicker($scope.options);
      $("#invoiceDatePicker").datepicker(
        "setDate",
        moment(journalEntry.invoiceDate).format("DD-MM-YYYY")
      );
      vm.invoiceDate = moment(journalEntry.invoiceDate).format("DD-MM-YYYY");

      $("#dueDatePicker").datepicker($scope.options);
      $("#dueDatePicker").datepicker(
        "setDate",
        moment(journalEntry.dueDate).format("DD-MM-YYYY")
      );
      vm.dueDate = moment(journalEntry.dueDate).format("DD-MM-YYYY");

      $("#journalDatePicker").datepicker($scope.options);
      $("#journalDatePicker").datepicker(
        "setDate",
        moment(journalEntry.journalDate).format("DD-MM-YYYY")
      );
      vm.journalDate = moment(journalEntry.journalDate).format("DD-MM-YYYY");
    }

    vm.removeJournalEntry = function(sale) {
      if ($state.current.name === "app.company.new.journalEntries") {
        $("#removeAttachmentModal").appendTo("app-content");
        $("#removeAttachmentModal").modal("show");
      } else {
        $("#removeModal").appendTo("#app-content");
        $("#removeModal").modal("show");
      }
    };

    vm.removeInbox = function() {
      $("#removeModal").modal("hide");
      JournalEntry.deleteById({
        id: journalEntry.id
      }).$promise.then(function() {
        console.log("deleted to Inbox");
      });
      setTimeout(function() {
        vm.close();
      }, 500);
    };

    vm.removePermanently = function() {
      $("#removeModal").modal("hide");
      JournalEntry.removePermanent({
        id: journalEntry.id
      }).$promise.then(function() {
        // console.log('deleted permenantly');
      });
      setTimeout(function() {
        vm.close();
      }, 500);
    };

    vm.saveJournalEntry = function() {
      vm.saving = true;
      var journalEntryCopy = $.extend({}, journalEntry);
      journalEntryCopy.journalDate = moment(
        vm.journalDate,
        "DD-MM-YYYY"
      ).toDate();
      journalEntryCopy
        .$save()
        .then(function() {
          vm.close(true);
          vm.saving = false;
        })
        .catch(function(response) {
          vm.saving = false;
          window.swal("Opslaan mislukt", response.data.error.message, "error");
        });
    };

    function initializeL() {
      if (!journalEntry.Lines || journalEntry.Lines.length===0) {
        journalEntry.Lines = [];
        vm.addItem();
      }
    }

    function initLoadedJournalEntry() {
      initializeL();
      dateformatting();
    }

    function loadJournalEntry() {
      journalEntry = JournalEntry.get({
        id: $stateParams.id,
        filter: {
          include: [
            'user',
            'events',
            {relation: "Attachment", scope: {include: ['comments']}},
            {
              relation: "payments",
              scope: {
                include: {
                  relation: "invoice",
                  scope: {
                    include: [
                      {
                        relation: "vendor",
                        scope: {
                          fields: {
                            name: true,
                            website: true
                          }
                        }
                      },
                      {
                        relation: "customer",
                        scope: {
                          fields: {
                            name: true,
                            website: true
                          }
                        }
                      }
                    ]
                  }
                }
              }
            }
          ]
        }
      });
      journalEntry.$promise.then(function() {
        initLoadedJournalEntry();
        if (journalEntry.payments) {
          paymentInvoices = journalEntry.payments.map(function(payment) {
            return payment.invoice;
          });
        }
      });
      vm.journalEntry = journalEntry;
      $scope.$parent.transaction = journalEntry;
    }

    if ($state.current.name === "app.company.new.journalEntries") {
      journalEntry = new JournalEntry();
      vm.journalEntry = journalEntry;
      journalEntry.invoiceDate = new Date();
      journalEntry.dueDate = new Date();
      // journalEntry.dueDate = moment().add(14, 'days').toDate();
      journalEntry.journalDate = new Date();
      attachment = Attachment.get({
        id: $stateParams.id,
        filter: { include: ["comments"] }
      });
      attachment.$promise.then(function() {
        var extractedData = attachment.extractedData;
        var transactionProposal = attachment.transactionProposal;
        if (extractedData) {
          if (extractedData.amounts) {
            vm.extractedNumbers = extractedData.amounts;
          }
          if (extractedData.text) {
            vm.extractedWords = $rootScope.extractWords(extractedData.text);
          }
        }

        if (extractedData && transactionProposal) {
          vm.journalEntry.journalDate = transactionProposal.journalDate || transactionProposal.invoiceDate;
          vm.journalEntry.description = transactionProposal.description;
          console.log('vm.journalEntry.description',transactionProposal.description)
          vm.journalEntry.Lines = transactionProposal.Lines || [];

          //Autofill description
          if (extractedData.text) {
            var descriptionMatch = extractedData.text.match(
              /JOURNAALPOST? ?:? ?(.*) nr\.\n/i
            );
            if (descriptionMatch) {
              vm.journalEntry.description = descriptionMatch[1];
            }
          }

        }

        vm.journalEntry.Attachment = attachment;
        $scope.$parent.transaction = vm.journalEntry;
      });
      setTimeout(function() {
        //  $state.go('app.company.sales.list');
        initLoadedJournalEntry();

        //  vm.invoiceDateChanged(vm.invoiceDate);
        if ($stateParams.id) {
          vm.journalEntry.attachmentId = $stateParams.id;
        }
        $scope.$parent.transaction = journalEntry;
      }, 200);
    } else {
      loadJournalEntry();
    }
  });
